<template>
  <div class="text-options-setting-dialog" :class="isBigScreen ? 'bc-setting' : ''">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" v-if="isShowSize" />
        <el-collapse-item title="文字" name="1">
          <div>
            <!-- 字体和颜色/字重和字号 -->
            <text-setting-complex-update
              :showTextShadowSetting="true"
              :showOverflowSetting="true"
              :enableVerticalAlign="showVerticalAlign"
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :letterSpacing.sync="letterSpacing"
              :activeArrangement.sync="activeArrangement"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
              :activeArrangementOrder.sync="activeArrangementOrder"
              :lineHeightType.sync="lineHeightType"
              :letterSpacingType.sync="letterSpacingType"
              :isThemeColor.sync="textIsThemeColor"
              :colorArr.sync="colorArr"
              :activeNameColor.sync="activeNameColor"
              :contentHasLimit.sync="contentHasLimit"
              :contentHasLimitRadio.sync="contentHasLimitRadio"
              :textLimitWords.sync="textLimitWords"
              :textLimitLines.sync="textLimitLines"
              :verticalAlign.sync="verticalAlign"
              :showHoverSet = "request_prefix ==='stage'?true:false"
              :hoverShowAllContent.sync="hoverShowAllContent"
              :wordOmitType.sync ="wordOmitType"
              :options="options"
            />
            <!-- <text-vertical-align-setting v-show="showVerticalAlign" :verticalAlign.sync="verticalAlign" /> -->
            <div v-show="options.pluginTag !== 'routerNav'">
              <!-- <div class="verticallyCenter mt16">
                <div class="mr16 keep-all">文字颜色</div>
                <cx-color-picker
                  class="custom-text-bg flex-box width-72"
                  :isThemeColor.sync="textIsThemeColor"
                  :colorArr.sync="colorArr"
                  :activeName.sync="activeNameColor"
                  :showSecondTab="true"
                >
                </cx-color-picker>
              </div> -->
              <div v-if="colorType === '线性渐变'" class="mt16">
                <span class="mr16 fs14">开始颜色</span>
                <div class="color-picker-container custom-text-bg mt8">
                  <el-color-picker
                    class=""
                    v-model="startColor"
                    color-format="rgb"
                    :show-alpha="true"
                  ></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ startColor }}</span>
                </div>
              </div>
              <div v-if="colorType === '线性渐变'" class="mt16">
                <span class="mr16 fs14">结束颜色</span>
                <div class="color-picker-container custom-text-bg mt8">
                  <el-color-picker class="" v-model="endColor" color-format="rgb" :show-alpha="true"></el-color-picker>
                  <span class="floatLeft color-text mr8">{{ endColor }}</span>
                </div>
              </div>
            </div>
            <div v-if="colorType !== '纯色'" class="mt16">
              <div class="slider-input-container paddingl0">
                <span class="mr16 fs14">渐变角度</span>
                <el-slider
                  :show-tooltip="false"
                  class="mr16"
                  style="width: 96px; height: 4px"
                  v-model="colorlinearGradientAngle"
                  :max="360"
                  :min="0"
                ></el-slider>

                <single-input
                  style="width: 68px; height: 28px"
                  :value.sync="colorlinearGradientAngle"
                  inputSuffixs="度"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="背景" name="2">
          <cx-background infoTips="支持上传图片" :background.sync="background" :options="options" imgType="10" />
        </el-collapse-item>
        <el-collapse-item title="边框" name="3">
          <div>
            <div class="content-item verticallyCenter mb8">
              <el-checkbox v-model="showBorder">显示边框</el-checkbox>
              <el-tooltip
                popper-class="width200"
                effect="dark"
                content="边框颜色为线性渐变或径向渐变时：背景颜色的透明度必须为1。此时背景模糊不生效；虚线、点线不生效。"
                placement="top"
                :open-delay="1000"
              >
                <span class="tips-btn icon-portal-info2"></span>
              </el-tooltip>
            </div>
            <cx-border
              v-if="showBorder"
              :borderWidth.sync="borderWidth"
              :borderStyle.sync="borderStyle"
              :borderColor.sync="borderColor"
              :borderIsThemeColor.sync="borderIsThemeColor"
              :activeNameColor.sync="borderActiveNameColor"
              :showGradientBorder="true"
              :options="options"
            />
          </div>
          <div class="content-item mt16">
            <border-radius
              :borderTypeFlag.sync="borderTypeFlag"
              :borderRadius.sync="borderRadius"
              :borderTopLeftRadius.sync="borderTopLeftRadius"
              :borderTopRightRadius.sync="borderTopRightRadius"
              :borderBottomRightRadius.sync="borderBottomRightRadius"
              :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              :sliderMax="paddingMax"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="4">
          <cx-padding
            :paddingTypeFlag.sync="textPaddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
          />
        </el-collapse-item>
        <el-collapse-item v-if="request_prefix === 'bigScreen'" title="动画" name="5">
          <big-screen-animate-set></big-screen-animate-set>
        </el-collapse-item>
        <el-collapse-item title="更多" name="6">
          <div class="content">
            <div class="verticallyCenter">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <widthAndSizeAndZindex
              :options="options"
              :ids="ids"
              showSetItem="rotate"
              class="mt16"
              v-if="request_prefix !== 'bigScreen'"
            />
            <div class="content-item mt16 verticallyCenter mb16">
              <span class="mr16">溢出</span>
              <text-setting-overflow :overFlowType.sync="textOverFlowType" style="flex: 1"></text-setting-overflow>
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
            <div class="content-item mt16">
              <public-style :options="options" :ids="ids"></public-style>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-show="$store.state.states.showPluginSetting" title="插件" name="7">
          <div class="setting-item">
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <asyncPluginSettingSubmit
      :pluginName="options.pluginName"
      componentName="text"
      :options="options"
      type="Setting"
      :rect_id="rect_id"
      :container_id="container_id"
    />
  </div>
</template>

<script>
import textSettingComplexUpdate from "@/modules/components/textSettingComplex_update.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingOverflow from "modules/components/textSettingOverflow"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import { withMethodsHistoryCombine } from "utils/revork"
import { isInAutoLayout } from "utils"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  name: "text-options-data",
  components: {
    textSettingComplexUpdate,
    TextSettingOverflow,
    widthAndSizeAndZindex,
    controlWidthAndSizeAndZindex,
    elementPluginSetting,
    rowColLayoutSize,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue"),
    publicStyle
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      activeNames: ["1", "2"],
      hoverOpt: [],
      this1: this,
      sliderMax: 360,
      paddingMax: 500,
      textTypeList: [
        {
          className: "icon-portal-h1",
          label: "h1",
          title: "一级标题"
        },
        {
          className: "icon-portal-h2",
          label: "h2",
          title: "二级标题"
        },
        {
          className: "icon-portal-h3",
          label: "h3",
          title: "三级标题"
        },
        {
          className: "icon-portal-h4",
          label: "h4",
          title: "四级标题"
        },
        {
          className: "icon-portal-plain-text",
          label: "a1",
          title: "正文"
        }
      ],
      translate: 0,
      showVerticalAlign: true
    }
  },
  computed: {
    ids() {
      console.log("text-setting", this.options)
      return this.$store.state.states.activeID
    },
    isShowSize() {
      return (this.options.type === "next" || this.options.type === "prev") && !isInAutoLayout ? false : true
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    colorArr: {
      get() {
        let color = this.options.colorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.color, 0],
              ["rgba(255, 255, 255, 0.8)", 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "colorArr", false, false, false, true)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "colorArr", false)
      }
    },
    activeNameColor: {
      get() {
        return this.options.activeNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "activeNameColor", false)
      }
    },
    content: {
      get() {
        return this.options.content
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowColor", "boxShadowColor", ["rgba(255,255,255,1)"])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowH", "boxShadowH", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowV", "boxShadowV", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowBlur", "boxShadowBlur", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "boxShadowSpread", "boxShadowSpread", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    textOverFlowType: {
      get() {
        // return this.options.textOverFlowType || "visible"
        return this.checkAndSetPrimaryVal(this.options, "textOverFlowType", "textOverFlowType", "visible")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textOverFlowType", false)
      }
    },
    textIsThemeColor: {
      get() {
        // return this.options.textIsThemeColor || false
        return this.checkAndSetPrimaryVal(this.options, "textIsThemeColor", "textIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    contentHasLimitRadio: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "contentHasLimitRadio", "contentHasLimitRadio", "行数")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimitRadio", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    textLimitWords: {
      get() {
        return this.options.textLimitWords || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitWords", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    activeArrangement() {
      return this.options.textAlign
    },

    colorlinearGradientAngle: {
      get() {
        return this.options.colorlinearGradientAngle || 90
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "colorlinearGradientAngle", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "主题色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    fontType: {
      get() {
        let type = this.options.hasOwnProperty("fontType") ? this.options.fontType : "h1"
        let index = this.textTypeList.findIndex(item => item.label === type)
        // 44 一个滑块的宽度
        this.translate = 44 * index
        return this.options.hasOwnProperty("fontType") ? this.options.fontType : "h1"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontType", false)
      }
    },
    getTranslate() {
      return {
        transform: `translateX(${this.translate}px)`
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.lineHeight = newVal > this.lineHeight ? newVal : this.lineHeight
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    colorType: {
      get() {
        return this.options.colorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorType", false)
      }
    },
    startColor: {
      get() {
        return this.options.startColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startColor", false)
      }
    },
    endColor: {
      get() {
        return this.options.endColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endColor", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    verticalAlign:{
      get() {
        return this.checkAndSetPrimaryVal(this.options, "verticalAlign", "verticalAlign", "top")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "verticalAlign", false)
        /**/
      }
    },
    hoverShowAllContent:{
      get() {
        // return this.checkAndSetPrimaryVal(this.options, "hoverShowAllContent", "hoverShowAllContent", false)
        return this.options.hoverShowAllContent || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverShowAllContent", false)
      }
    },
    wordOmitType:{
      get() {
        return this.options.wordOmitType || "hidden"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "wordOmitType", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
        this.showVerticalAlign = newVal === 'vertical-lr' ? false :true
        this.verticalAlign = "top"
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    // 边距
    textPaddingTypeFlag: {
      get() {
        let defaultType = 2
        return this.checkAndSetPrimaryVal(this.options, "textPaddingTypeFlag", "textPaddingTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderRadius", "borderRadius", this.borderTopLeftRadius)
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
            [newVal, newVal, newVal, newVal, newVal],
            [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
              "borderRadius"
            ],
            false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopLeftRadius", "borderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderTopRightRadius", "borderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomRightRadius", "borderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderBottomLeftRadius", "borderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if(this.options.showBorder === undefined){
          if(this.options.borderWidth){
            showBorder = true
          }else{
            showBorder = false
          }
        }else{
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if(newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    // 描边
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderColor", "borderColor", "rgba(255,255,255,0)")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderStyle", "borderStyle", "solid")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderIsThemeColor", "borderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    borderActiveNameColor: {
      get() {
        return this.options.borderActiveNameColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderActiveNameColor", false)
      }
    }
  },
  methods: {
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    changeTextType(value) {
      this.fontType = value
      switch (value) {
        case "h1":
          this.fontSize = "24"
          this.fontWeight = 600
          this.lineHeight = "34"
          break
        case "h2":
          this.fontSize = "20"
          this.fontWeight = 600
          this.lineHeight = "28"
          break
        case "h3":
          this.fontSize = "18"
          this.fontWeight = 600
          this.lineHeight = "25"
          break
        case "h4":
          this.fontSize = "16"
          this.fontWeight = 600
          this.lineHeight = "22"
          break
        case "a1":
          this.fontSize = "14"
          this.fontWeight = 400
          this.lineHeight = "22"
          break
      }
    }
  }
})
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.paddingl0 {
  padding-left: 0;
}

::v-deep .boxshadow-wrap {
  z-index: 1002;
}
::v-deep .boxshadow-wrap .ml24 {
  margin-left: 2px;
  margin-right: 10px;
}
.bc-setting ::v-deep.font-arrangement-btn {
  padding: 3px;
  border: none;
}
.lightColor444 {
  color: rgba(0, 0, 0, 0.4);
}
.deepColor444 {
  color: rgba(255, 255, 255, 0.4);
}
.font-arrangement-btn {
  flex: 1 1 0%;
}
.font-arrangement-btn span {
  width: calc((100% / 5));
}
.font-arrangement-btn span.btn-active {
  width: calc((100% - 6px) / 5);
}
.font-type-btn span {
  font-size: 18px;
  height: 26px;
  line-height: 26px;
}
.font-type-btn span i {
  line-height: 26px;
}
.font-type-btn {
  height: 32px;
}
.flex-box {
  flex: 1;
}
.el-radio {
  margin-right: 16px;
}
.el-radio:last-child {
  margin-right: 0;
}
</style>
